module.exports = __webpack_public_path__ + "img/1440.046255b9.jpg";